export const StenaLine = 'STENALINE';

export const AML = 'AML';



// WEBPACK FOOTER //
// ./src/store/company/constants.js